import React from "react";
import { Box, Dialog } from "@mui/material";
import Slide from "@mui/material/Slide";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import CloseIcon from "@mui/icons-material/Close";
import "./dialog.scss";
import Text from "../text/Text";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={props.direction} ref={ref} {...props} />;
});

function DialogBox({
  isOpenModal,
  setIsOpenModal,
  modalHeader,
  handleAction,
  directionToOpen,
  isShowCloseIcon = false,
  showAppBar = true,
  additionalSymbol = null,
  additionalText = null,
  additionalTextColor = "#000000",
  additionalAction,
  fullScreen = true,
  className = "",
  showFooter = false,
  footerComponent = null,
  ...props
}) {
  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpenModal}
      onClose={() => setIsOpenModal(false)}
      TransitionComponent={Transition}
      className={`dialog-wrapper ${className}`}
      TransitionProps={{
        direction: directionToOpen,
        appear: false,
      }}
      disablePortal={true}
      contextMenu="options-layout-wrapper"
      sx={props?.sx}
    >
      {showAppBar && (
        <AppBar sx={{ position: "relative", backgroundColor: "#ffff" }}>
          <Toolbar className="dialog-toolbar">
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => handleAction()}
              aria-label="close"
            >
              {isShowCloseIcon ? (
                <CloseIcon
                  sx={{ color: "#848B9E", height: "24px", width: "24px" }}
                />
              ) : (
                <ArrowBackOutlinedIcon
                  sx={{ color: "#848B9E", height: "24px", width: "24px" }}
                />
              )}
            </IconButton>
            <Text
              size={18}
              className="default-text"
              font="semibold"
              sx={{ flex: 1 }}
            >
              {modalHeader}
            </Text>
            {additionalText && (
              <Text
                size={14}
                font="semibold"
                sx={{ color: additionalTextColor, cursor: "pointer" }}
                className="txt-uppercase"
                onClick={() => additionalAction?.()}
              >
                {additionalText}
              </Text>
            )}
            {additionalSymbol && additionalSymbol}
          </Toolbar>
        </AppBar>
      )}
      <Box className="full-screen-modal">{props.children}</Box>
      {showFooter && footerComponent}
    </Dialog>
  );
}

export default DialogBox;
